import { FC } from 'react'
import Swal from 'sweetalert2'
import { deleteModelo, getModeloById } from '../../core/_requests'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { ModeloList } from '../../core/_models'
import { ModeloModal } from '../../components/modal/ModeloModal'
import { ModeloVinculosModal } from '../../components/modal/ModeloVinculosModal'
import { useT } from '_metronic/i18n/Metronici18n'
import {
  IconPaths,
  ModalSize,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '_metronic/helpers'
import { RowActions, useModal, useToast } from 'app/components'

type Props = {
  modelo: ModeloList
}

export const ModelosActionsCell: FC<Props> = ({ modelo }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const { t } = useT()
  const nome = modelo.titulo || t('modelo.label')

  const openEditModal = () =>
    showModal({
      title: `${t('common.edit')} ${t('modelo.label')}`,
      content: <ModeloModal />,
      size: ModalSize.Medium,
      fetchers: {
        modelo: () => getModeloById(modelo.id),
      },
    })

  const openVinculosModal = () =>
    showModal({
      title: `${t('common.manage')} ${t('vinculo.plural.lowercase')}`,
      content: <ModeloVinculosModal />,
      size: ModalSize.Large,
      fetchers: {
        modelo: () => getModeloById(modelo.id),
      },
    })

  const askDelete = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Excluir modelo?',
      text: `${nome} será excluído. Para só tirá-lo de uso, edite e marque como inativo.`,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      await deleteModelo(modelo.id)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} foi excluído.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: t('common.edit'), onClick: openEditModal, icon: IconPaths.Pen }}
      items={[
        {
          label: `${t('common.manage')} ${t('vinculo.plural.lowercase')}`,
          onClick: openVinculosModal,
        },
        { label: t('common.delete'), onClick: askDelete, danger: true },
      ]}
    />
  )
}
